(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/assets/javascripts/content-view.js') >= 0) return;  svs.modules.push('/modules/racing-game/assets/javascripts/content-view.js');
"use strict";

const {
  Route,
  Switch
} = svs.app.ReactRouter;
const {
  Statistics
} = svs.racing_game.components.statistics;
const {
  StaticTabs,
  StaticTabsContent
} = svs.racing_game.components.staticTabs;
const {
  StreamPlayerDesktopGameContainer
} = svs.racing.streamplayer;
const {
  statisticsRoutes,
  racingRoutes,
  racingMyGamesRoutes
} = svs.racing_game.routes;
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const ContentView = _ref => {
  let {
    staticTabs
  } = _ref;
  return React.createElement(React.Fragment, null, !isSelfService && React.createElement("div", {
    className: "stream-player-holder"
  }, React.createElement(StreamPlayerDesktopGameContainer, null)), React.createElement(Switch, null, React.createElement(Route, {
    exact: true,
    path: statisticsRoutes
  }, React.createElement("div", {
    className: "statistics-slider-panel"
  }, React.createElement(Statistics, null))), React.createElement(Route, {
    exact: true,
    path: [...racingRoutes, ...racingMyGamesRoutes]
  }, React.createElement(StaticTabs, {
    tabs: staticTabs
  }), React.createElement(StaticTabsContent, {
    tabs: staticTabs
  }))));
};
svs.racing_game.ContentView = ContentView;

 })(window);